<template>
  <div class="p-4">
    <!-- Header -->
    <div class="d-flex justify-content-between align-items-center mb-3">
      <p class="mb-0 text-muted">
        Trámite: <strong>{{ idTramite }}</strong> —
        Tipo: <strong>{{ tipoTexto }}</strong>
      </p>
    </div>

    <!-- Error -->
    <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>

    <!-- DataTable -->
    <DataTable
      :data="observaciones"
      :columns="columnas"
      idField="idPlaDetObs"
      :acciones="false"
      :mostrarBotonNuevo="false"
      :mostrarBotonTodos="true"
      :mostrarBotonExcel="true"
      mensajeVacio="No hay observaciones para este trámite."
      @refresh="fetchData"
    />
  </div>
</template>

<script>
import api      from "@/services/api";
import DataTable from "@/components/DataTable.vue";

export default {
  name: "ObservacionesTramiteDetalle",
  components: { DataTable },
  props: {
    idTramite:       { type: [Number, String], required: true },
    observacionTipo: { type: String,           required: true },
  },
  data() {
    return {
      observaciones: [],
      errorMessage:  "",
      columnas: [
        { field: "planillaNumeroInt",      label: "Número"                    },
        { field: "planillaNombre",         label: "Paciente"                  },
        { field: "elementoCodigo",         label: "Código"                    },
        { field: "elementoNombre",         label: "Descripción"               },
        { field: "observacionDescripcion", label: "Observación estándar",
          format: (v) => v || "-"                                              },
        { field: "descripcion",            label: "Obs. complementaria",
          format: (v) => v || "-"                                              },
        { field: "observacionTipo",        label: "Tipo",
          format: (v) => v || "-"                                              },
      ],
    };
  },
  computed: {
    tipoTexto() {
      if (this.observacionTipo === "M") return "Auditoría Médica";
      if (this.observacionTipo === "D") return "Gestión Documental";
      return this.observacionTipo;
    },
  },
  methods: {
    async fetchData() {
      if (!this.idTramite) {
        this.errorMessage  = "Parámetro idTramite no definido.";
        this.observaciones = [];
        return;
      }
      this.errorMessage = "";
      try {
        const { data } = await api.get(
          `/vwpladetobss/tramite-tipo/${this.idTramite}/${this.observacionTipo}`
        );
        this.observaciones = Array.isArray(data) ? data : [];
      } catch (err) {
        const status = err.response?.status;
        this.errorMessage =
          status === 403 ? "No autorizado (403)" :
          status === 404 ? "Recurso no encontrado (404)" :
          err.response?.data?.message || "Error de red o el servidor no responde.";
        this.observaciones = [];
      }
    },
  },
  mounted() { this.fetchData(); },
  watch: {
    idTramite(n, o) { if (n !== o) this.fetchData(); },
  },
};
</script>